import { faArrowRight, faCheckCircle, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '@shared/hooks/usePermissions';

interface CompletedMessageProps {
  preparationId: number;
  status: number;
}

export const CompletedMessage: React.FC<CompletedMessageProps> = ({ preparationId, status }) => {
  const { t } = useTranslation('pickingModule');
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  // 🎯 Verificar permisos de preparación
  const canPacking = hasPermission('preparations.packing');
  const canView = hasPermission('preparations.view');

  const handleGoToPacking = () => {
    navigate(`/order-preparation/packing/${preparationId}`);
  };

  const handleStartNewPicking = () => {
    navigate('/order-preparation');
  };

  return (
    <div className="bg-green-50 dark:bg-green-950/20 border border-green-200 dark:border-green-800 rounded-lg p-6">
      <div className="flex flex-col items-center space-y-4">
        <div className="flex items-center space-x-3">
          <FontAwesomeIcon icon={faCheckCircle} className="w-6 h-6 text-green-500" />
          <span className="text-lg font-medium text-green-700 dark:text-green-300">
            {t('messages.picking_completed_simple')}
          </span>
        </div>

        {/* Botones solo para status 2 (picking completado, listo para packing) */}
        {status === 2 && (
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            {canPacking && (
              <button
                onClick={handleGoToPacking}
                className="flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-lg font-medium transition-colors min-w-[140px]"
              >
                <FontAwesomeIcon icon={faArrowRight} className="w-4 h-4" />
                <span>{t('actions.go_to_packing')}</span>
              </button>
            )}

            {canView && (
              <button
                onClick={handleStartNewPicking}
                className="flex items-center justify-center space-x-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2.5 rounded-lg font-medium transition-colors min-w-[140px]"
              >
                <FontAwesomeIcon icon={faPlus} className="w-4 h-4" />
                <span>{t('actions.new_picking')}</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
